// import queryString from "query-string";
import {getTransactionColumn} from "./getTransactionColumn";
import {getTransactionColumnRender} from "./getTransactionColumnRender";
import { TransactionColKey } from "../../../enums/TransactionColKey";
import { getTransactionCustomFieldColumns } from "./getTransactionCustomFieldColumns";

/**
 * @param columnKeys: Array of { key: TransactionColKey, required: boolean, defaulto: boolean }
 * @param props
 * @returns {*}
 */
export function withTransactionColumnInfo(columnKeys, props = {}, fields = {transaction: [], contact: []}) {
    // const { location } = props;
    // const params = queryString.parse(location?.search);

    const columnKeysWithCustomFields = columnKeys.map(column => {
        if (column.key === TransactionColKey.custom_fields)
            return getTransactionCustomFieldColumns(fields); // return multi-columns [{key,title,width,render}, ...]

        return column;
    }).flat();

    const transactionColumnInfo = columnKeysWithCustomFields
        .map(({ key, required = false, defaulto = false, ...restProps }) => ({
            key,
            dataIndex: key,
            required,
            defaulto,
            ...getTransactionColumn(key, fields),
            ...restProps,
            render: getTransactionColumnRender(key, props, fields),
        }));

    return transactionColumnInfo;
}
